import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { r as i } from "../internals/require-object-coercible.js";
import { t as n } from "../internals/to-integer-or-infinity.js";
import { t as o } from "../internals/to-string.js";
import { f as s } from "../internals/fails.js";
var a = t("".charAt);
r({
  target: "String",
  proto: !0,
  forced: s(function () {
    return "\uD842" !== "\uD842\uDFB7".at(-2);
  })
}, {
  at: function at(r) {
    var t = o(i(this)),
      s = t.length,
      e = n(r),
      f = e >= 0 ? e : s + e;
    return f < 0 || f >= s ? void 0 : a(t, f);
  }
});